<template>
  <div :class="'custom-margin-top-pathern partner ' + extraClass ? 'custom-partner-top' : ''">
    <div class="container m-auto">
      <div class="d-flex justify-content-center">
<!--        <script-->
<!--          src="//ad.lomadee.com/banners/script.js?sourceId=37159827&dimension=1&height=90&width=728&method=0"-->
<!--          type="text/javascript"-->
<!--          language="javascript"-->
<!--        ></script>-->
      </div>
    </div>
  </div>
<!--  <div :class="'custom-margin-top-pathern partner ' + extraClass ? 'custom-partner-top' : ''">-->
<!--    <div class="container">-->
<!--      <div-->
<!--        class="partner_block d-flex justify-content-between"-->
<!--        data-slick="{&quot;slidesToShow&quot;: 6}"-->
<!--      >-->
<!--        <div-->
<!--          v-for="item in items"-->
<!--          :key="'key_' + item.id"-->
<!--          class="partner&#45;&#45;logo"-->
<!--        >-->
<!--          <a-->
<!--            class="cursor-pointer"-->
<!--            v-on:click="goToLink(item.slug)"-->
<!--          >-->
<!--            <img-->
<!--              :src="storage + '/' + item.logo"-->
<!--              :alt="item.nome"-->
<!--              :title="item.nome"-->
<!--              class="custom-partiner-width"-->
<!--            >-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
export default {
    props: {
        extraClass: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default () {
                return [];
            }
        },
        storage: {
            type: String,
            default () {
                return '';
            }
        }
    },
    methods: {
        goToLink (slug) {
            document.location.href = '/marcas/' + slug;
        }
    }
};
</script>
